import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/Reveal";

const IMG =
  "https://images.unsplash.com/photo-1552566626-52f8b828add9?q=80&w=2000&auto=format&fit=crop";

const Intro = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section id="about" data-testid="intro-section" className="bg-ivory py-28 lg:py-40">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="eyebrow mb-6">The Firm</p>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] text-ink">
                People.
                <br />
                <span className="italic text-bronze">Passion.</span>
                <br />
                Performance.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:pt-20">
            <Reveal delay={0.15}>
              <p className="text-lg lg:text-xl text-ink/80 font-light leading-relaxed max-w-2xl">
                BR Hospitality is a boutique recruitment and hospitality advisory firm dedicated to
                luxury hotels, resorts, restaurants and lifestyle hospitality concepts.
              </p>
              <p className="mt-6 text-sm lg:text-base text-ink/60 leading-relaxed max-w-2xl">
                We combine international operational experience with targeted executive search to
                identify professionals who do more than fill positions — they strengthen culture,
                elevate guest experience and contribute to long-term brand success.
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-20 lg:mt-28">
          <div ref={ref} className="relative overflow-hidden h-[50vh] lg:h-[70vh]">
            <motion.img
              style={{ y }}
              src={IMG}
              alt="Warm refined restaurant interior"
              className="absolute inset-0 w-full h-[120%] object-cover"
            />
            <div className="absolute inset-0 bg-ink/10" />
            <div className="absolute bottom-6 left-6 lg:bottom-10 lg:left-10">
              <p className="text-[10px] tracking-[0.35em] uppercase text-ivory/90">
                Boutique · Personal · Exclusive
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Intro;
